import { render, staticRenderFns } from "./IndumentariaList.vue?vue&type=template&id=2ae8bd8a"
import script from "./IndumentariaList.vue?vue&type=script&setup=true&lang=js"
export * from "./IndumentariaList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports